import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import config from 'config';
import DesktopBreadcrumbs from './DesktopBreadcrumbs';

import { getCategoryChildCategories, getCategoryBreadcrumbs } from '../../utils/breadcrumbsUtils';

const MAIN_CATEGORY_ID = config.ROOT_SHOP_TAG_ID;

export default class DesktopCatalogueBreadcrumbs extends PureComponent {
  static propTypes = {
    baseName: PropTypes.string,
    baseNameWithMenu: PropTypes.string,
    baseNameNewUI: PropTypes.string,
    basePath: PropTypes.string.isRequired,
    childCategories: PropTypes.arrayOf(
      PropTypes.shape({
        children: PropTypes.array,
        id: PropTypes.string,
        name: PropTypes.string.isRequired,
      })
    ),
    pageParameters: PropTypes.object.isRequired,
    rootLink: PropTypes.string,
    withMenu: PropTypes.bool,
    withNewUI: PropTypes.bool,
  };

  static defaultProps = {
    baseName: 'Shop',
    baseNameWithMenu: 'Aisles',
    baseNameNewUI: 'Browse',
    withMenu: false,
    withNewUI: false,
  };

  getBreadcrumbsCategories = () => {
    const {
      baseName,
      baseNameWithMenu,
      baseNameNewUI,
      basePath,
      childCategories = [],
      pageParameters,
      rootLink,
      withMenu,
      withNewUI,
    } = this.props;

    const rootItem = withMenu ?
      {
        id: MAIN_CATEGORY_ID,
        name: withNewUI ? baseNameNewUI : baseNameWithMenu,
        link: rootLink || basePath,
        menuCategories: getCategoryChildCategories(
          {
            id: MAIN_CATEGORY_ID,
            name: baseNameWithMenu,
          },
          childCategories,
          {
            index: 1,
            pageParameters,
            basePath,
          }
        ),
      } :
      {
        name: withNewUI ? baseNameNewUI : baseName,
        link: rootLink || basePath,
      };

    return [
      rootItem,
      ...getCategoryBreadcrumbs({ basePath, pageParameters, childCategories }),
    ];
  };

  render() {
    const { withNewUI, withMenu } = this.props;

    return (
      <DesktopBreadcrumbs
        items={this.getBreadcrumbsCategories()}
        withNewUI={withNewUI}
        withMenu={withMenu}
      />
    );
  }
}
